import { createSlice } from '@reduxjs/toolkit';
import {
  AddSkills,
  UpdateSkills,
  GetPostById,
  DeleteSkills,
} from '../services/SkillService';
import axios from 'components/Axios';
import { OrderSkill } from 'redux/APIEndPoint';

export const SkillsSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addSkills: '',
    skillsList: [],
    getSkills: '',
    updateActivities: '',
  },
  reducers: {
    addSkills: (state, action) => {
      state.addSkills = [action.payload];
    },
    skillsList: (state, action) => {
      state.skillsList = [action.payload];
    },
    getSkills: (state, action) => {
      state.getSkills = [action.payload];
    },
    updateActivities: (state, action) => {
      state.updateActivities = [action.payload];
    },
  },
});

export const InsertSkills = (data, userId) => async () => {
  const payload = {
    skills: [
      {
        skill: data.skill,
        experience: data.experience,
      },
    ],
    createdById: userId,
  };
  return AddSkills(payload);
};

export const updateSkillsList = (data) => async () => {
  const payload = {
    skill: data.skill,
    experience: data.experience,
  };
 return UpdateSkills(payload, data);
};

export const getSkillsByuserId = () => async (dispatch) => {
  GetPostById().then((response) => {
    dispatch(getSkills(response.data));
  });
};

export const deleteSkills = (data) => async () => {
  return DeleteSkills(data);
};

export const DragAndDropSkills = (data) => async () => {
  const promise = axios.post(OrderSkill, { skillIds: data });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export const { skillsList, addSkills, updateActivities, getSkills } =
  SkillsSlice.actions;

export default SkillsSlice.reducer;
